import { defineComponent as _defineComponent } from 'vue'
import _ from 'lodash';
import { IPermissionsFeatures, UserRole } from '@/store/modules/userRoles/types';
import useStore from '@/utils/store/common';
import { computed, onMounted, ref, watch } from 'vue';
import { buildPathOfPermissions,
  checkRightsAllChildren,
  permissionsListOfTree,
  reducePathOfPermissions,
  reduceTreeOfPermissions,
  updateAllChildren,
  updateTree } from './utils';
import './styles/permissions-list.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionsList',
  props: {
  permissions:
  {
    type: Array,
    default: () => ([] as IPermissionsFeatures[])
  },

  role:
  {
    type: Object,
    default: () => ({} as UserRole)
  },
  edition:
  {
    type: Boolean
  },
  reload:
  {
    type: Boolean
  }
},
  emits: ['draftUpdated', 'reloaded'],
  setup(__props, { emit }) {

const props = __props;





const store = useStore();

const expanded = ref(['Access Management', 'Device Management', 'Tolling']);

const checkChildren = checkRightsAllChildren;

const features = ref([] as any[]);

const getEdition = computed(() => store.getters['userRoles/getEdition']);

function initFeatures() {
  const allPaths = buildPathOfPermissions(props.permissions);
  const reducedPaths = reducePathOfPermissions(allPaths);
  const reducedTree = reduceTreeOfPermissions(reducedPaths);
  features.value = reducedTree;
}

onMounted(async () => {
  await store.dispatch('userRoles/fetchPermissionsFeatures');
  initFeatures();
});

function isExpanded(featureName: string) {
  return expanded.value.includes(featureName);
}

function expand(featureName: string) {
  if (!isExpanded(featureName)) {
    expanded.value.push(featureName);
  }
}

function unexpand(featureName: string) {
  if (isExpanded(featureName)) {
    expanded.value = expanded.value.filter(name => name !== featureName);
  }
}

function buttonClass(right: boolean, rightName: string) {
  return (right ? `${rightName} rights set` : `${rightName} rights notset`);
}

function check(permission: string, right: string) {
  const result = checkRightsAllChildren(features.value, permission, right, false);
  return result.length !== 1 ? undefined : result[0];
}

function updateChildren(permission: string, right: string, value: boolean) {
  features.value = updateAllChildren(features.value, permission, right, value, false);
  if (right === 'write' && value) {
    features.value = updateAllChildren(features.value, permission, 'read', value, false);
  } else if (right === 'read' && !value) {
    features.value = updateAllChildren(features.value, permission, 'write', value, false);
  }
}

function updateWrite(feature: any) {
  const editedFeature = feature;
  editedFeature.data.write = !feature.data.write;
  if (feature.data.read) {
    editedFeature.data.read = feature.data.read || feature.data.write;
  }
  return editedFeature.data;
}

function updateRead(feature: any) {
  const editedFeature = feature;
  editedFeature.data.read = !feature.data.read;
  editedFeature.data.write = feature.data.write && feature.data.read;
  return editedFeature.data;
}

async function onRoleChange() {
  await store.dispatch('userRoles/fetchPermissionsFeatures');
  initFeatures();
  const rolePermissions = store.getters['userRoles/getPermissionsFeaturesOfCurrentlySelectedUserRole'];
  if (rolePermissions) {
    _.each(rolePermissions, (permission: any) => {
      features.value = updateTree(features.value, permission);
    });
    emit('draftUpdated', permissionsListOfTree(features.value));
  }
}

watch(
  () => props.role,
  () => onRoleChange(),
  {
    immediate: true,
    deep: true
  }
);

watch(
  () => props.reload,
  () => {
    onRoleChange();
    emit('reloaded');
  },
  {
    immediate: true
  }
);

watch(
  () => features.value,
  () => {
    if (props.edition) {
      emit('draftUpdated', permissionsListOfTree(features.value));
    }
  },
  {
    immediate: true,
    deep: true
  }
);

return { __sfc: true,props, emit, store, expanded, checkChildren, features, getEdition, initFeatures, isExpanded, expand, unexpand, buttonClass, check, updateChildren, updateWrite, updateRead, onRoleChange }
}

})